(function () {
  'use strict';
  var injected = false;

  /* ===== CALLOUT INJECTION ===== */
  function findRte() {
    return (
      document.querySelector('.blog-post-content .rte') ||
      document.querySelector('.blog-post-content') ||
      document.querySelector('rte-formatter') ||
      document.querySelector('.rte') ||
      document.querySelector('.article-template__content') ||
      document.querySelector('article .rte') ||
      document.querySelector('main .rte')
    );
  }

  function findFaqHeading(rte) {
    var headings = rte.querySelectorAll('h1, h2, h3');
    for (var i = 0; i < headings.length; i++) {
      var t = (headings[i].textContent || '').toLowerCase();
      if (/\bfaq\b|frequently\s+asked/i.test(t)) return headings[i];
    }
    return null;
  }

  function collectParagraphs(rte) {
    var paragraphs = [];
    rte.querySelectorAll(':scope > p, :scope > div > p').forEach(function (p) {
      if ((p.textContent || '').trim().length > 40) paragraphs.push(p);
    });
    if (paragraphs.length < 5) {
      var seen = paragraphs.slice();
      rte.querySelectorAll('p').forEach(function (p) {
        if ((p.textContent || '').trim().length > 40 && seen.indexOf(p) === -1) seen.push(p);
      });
      paragraphs = seen;
    }
    return paragraphs;
  }

  function tryInject() {
    if (injected) return true;
    var wrap = document.querySelector('[data-atl-cb-wrap]');
    if (!wrap) return false;
    var rte = findRte();
    if (!rte) return false;

    var quiz = wrap.querySelector('[data-atl-callout="quiz"]');
    var card1 = wrap.querySelector('[data-atl-callout="card1"]');
    var card2 = wrap.querySelector('[data-atl-callout="card2"]');

    var paragraphs = collectParagraphs(rte);
    if (paragraphs.length < 3) return false;

    var n = paragraphs.length;
    var quizIdx = 1;
    var card1Idx = Math.max(quizIdx + 1, Math.floor(n * 0.30));
    var card2Idx = Math.min(n - 2, Math.max(card1Idx + 2, Math.floor(n * 0.70)));

    var faqHeading = findFaqHeading(rte);

    if (quiz && paragraphs[quizIdx]) {
      paragraphs[quizIdx].insertAdjacentElement('afterend', quiz);
      quiz.removeAttribute('hidden');
    }
    if (card1 && paragraphs[card1Idx]) {
      paragraphs[card1Idx].insertAdjacentElement('afterend', card1);
      card1.removeAttribute('hidden');
    }
    if (card2) {
      if (faqHeading && rte.contains(faqHeading)) {
        faqHeading.parentNode.insertBefore(card2, faqHeading);
      } else if (paragraphs[card2Idx]) {
        paragraphs[card2Idx].insertAdjacentElement('afterend', card2);
      }
      card2.removeAttribute('hidden');
    }

    injected = true;
    return true;
  }

  /* ===== QUIZ MODAL STATE MACHINE ===== */
  var quizBound = false;
  var answers = {};
  var products = null;

  function loadProducts() {
    if (products !== null) return products;
    var node = document.querySelector('[data-atl-qm-products]');
    if (!node) return (products = {});
    try {
      products = JSON.parse(node.textContent || '{}');
    } catch (e) {
      console.error('[atl-quiz] product JSON parse failed', e);
      products = {};
    }
    return products;
  }

  function pickPrimary(a) {
    var style = a.style, occasion = a.occasion, type = a.type;
    /* 29/09/26 : Atlas ne vend pas de boutons de manchette -> bagues */
    if (type === 'ring') return (style === 'statement' || style === 'bold' || occasion === 'formal') ? 'ring-signet' : 'ring-tungsten';
    if (type === 'bracelet') {
      if (style === 'minimal') return 'bracelet-leather';
      if (style === 'statement') return 'bracelet-cuban';
      if (style === 'classic') return 'bracelet-leather';
      if (style === 'bold') return occasion === 'active' ? 'bracelet-cuban' : 'bracelet-tennis';
    }
    if (type === 'chain') {
      if (style === 'minimal') return 'chain-beaded';
      if (style === 'statement') return 'chain-cuban';
      if (style === 'classic') return 'chain-cross';
      if (style === 'bold') return 'chain-cuban';
    }
    if (type === 'any') {
      if (style === 'minimal') return 'chain-beaded';
      if (style === 'statement') return 'chain-cuban';
      if (style === 'classic') return 'bracelet-leather';
      if (style === 'bold') return 'bracelet-cuban';
    }
    return 'chain-cuban';
  }

  // Renvoie un tableau de 3 slots : primary + complement + accessory
  function recommend(a) {
    var primary = pickPrimary(a);
    var style = a.style, occasion = a.occasion;

    // Complement : si bracelet -> chain, si chain -> bracelet, sinon cuban
    var complement;
    if (primary.indexOf('bracelet-') === 0) {
      complement = style === 'minimal' ? 'chain-beaded' : (style === 'classic' ? 'chain-cross' : 'chain-cuban');
    } else if (primary.indexOf('chain-') === 0) {
      complement = style === 'minimal' ? 'bracelet-leather' : (style === 'classic' ? 'bracelet-leather' : 'bracelet-cuban');
    } else {
      complement = style === 'minimal' ? 'chain-beaded' : 'chain-cuban';
    }

    // Accessory : cufflinks si formal/classic, sinon tennis ou cross pour la touche
    var accessory;
    if (primary.indexOf('ring-') === 0) {
      accessory = style === 'minimal' ? 'bracelet-leather' : 'bracelet-tennis';
    } else if (occasion === 'formal' || style === 'classic') {
      accessory = 'ring-signet';
    } else if (style === 'statement' || style === 'bold') {
      accessory = 'bracelet-tennis';
    } else {
      accessory = 'chain-cross';
    }

    // Dedupe
    if (complement === primary) complement = primary.indexOf('chain') === 0 ? 'bracelet-leather' : 'chain-cuban';
    if (accessory === primary || accessory === complement) {
      accessory = primary.indexOf('chain') === 0 ? 'ring-tungsten' : 'chain-cross';
      if (accessory === primary || accessory === complement) accessory = 'bracelet-tennis';
    }

    return [primary, complement, accessory];
  }

  function buildHeadline(slot, a) {
    var map = {
      'bracelet-leather': 'Your piece: the leather essential.',
      'bracelet-beaded':  'Your piece: the layering bracelet.',
      'bracelet-cuban':   'Your piece: the Cuban bracelet.',
      'bracelet-tennis':  'Your piece: the unexpected tennis.',
      'chain-cuban':      'Your piece: the signature Cuban chain.',
      'chain-cross':      'Your piece: the cross chain.',
      'chain-beaded':     'Your piece: the minimal chain.',
      'ring-signet':      'Your piece: the signet ring.',
      'ring-tungsten':    'Your piece: the everyday band.',
      'cufflinks':        'Your piece: the cufflinks for the days that count.'
    };
    var T = window.ATL_QM_T || {};
    return T[slot] || map[slot] || T._default || 'Your piece, hand-picked.';
  }

  function showScreen(modal, name) {
    var screens = modal.querySelectorAll('[data-atl-qm-screen]');
    screens.forEach(function (s) {
      if (s.getAttribute('data-atl-qm-screen') === name) s.removeAttribute('hidden');
      else s.setAttribute('hidden', '');
    });
    var bar = modal.querySelector('[data-atl-qm-bar]');
    if (bar) {
      var pct = { intro: 0, q1: 25, q2: 50, q3: 75, result: 100 }[name] || 0;
      bar.style.width = pct + '%';
    }
  }

  function openModal() {
    var modal = document.querySelector('[data-atl-quiz-modal]');
    if (!modal) return;
    answers = {};
    showScreen(modal, 'intro');
    modal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    var closeBtn = modal.querySelector('[data-atl-quiz-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal() {
    var modal = document.querySelector('[data-atl-quiz-modal]');
    if (!modal) return;
    modal.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }

  function pickFromSlot(prods, slot) {
    var arr = prods[slot];
    if (!arr) return null;
    // Schema: { "slot": [ {url,title,price,image}, ... ] }
    if (Array.isArray(arr)) {
      if (!arr.length) return null;
      return arr[Math.floor(Math.random() * arr.length)];
    }
    // Backwards-compat: { "slot": {url,title,price,image} }
    return arr;
  }

  function renderResult(modal) {
    var slots = recommend(answers); // [primary, complement, accessory]
    var prods = loadProducts();
    var picks = [];
    for (var i = 0; i < 3; i++) {
      var p = pickFromSlot(prods, slots[i]);
      if (!p) p = pickFromSlot(prods, 'chain-cuban');
      if (!p) {
        var keys = Object.keys(prods);
        if (keys.length) p = pickFromSlot(prods, keys[0]);
      }
      picks.push(p);
    }
    if (!picks.filter(Boolean).length) {
      showScreen(modal, 'intro');
      return;
    }

    var headline = modal.querySelector('[data-atl-qm-result-headline]');
    if (headline) headline.textContent = buildHeadline(slots[0], answers);

    // Hydrate each of the 3 cards
    var cards = modal.querySelectorAll('[data-atl-qm-rslot]');
    cards.forEach(function (card, idx) {
      var p = picks[idx];
      if (!p) { card.style.display = 'none'; return; }
      card.style.display = '';
      card.setAttribute('href', p.url);
      var img = card.querySelector('[data-atl-qm-rimg]');
      var name = card.querySelector('[data-atl-qm-rname]');
      var price = card.querySelector('[data-atl-qm-rprice]');
      if (img) { img.setAttribute('src', p.image); img.setAttribute('alt', p.title); }
      if (name) name.textContent = p.title;
      if (price) price.textContent = p.price;
    });

    showScreen(modal, 'result');
  }

  function bindQuiz() {
    if (quizBound) return;
    var modal = document.querySelector('[data-atl-quiz-modal]');
    if (!modal) return;
    quizBound = true;

    // Open triggers (inside the inline quiz banner)
    document.addEventListener('click', function (e) {
      var openTrigger = e.target.closest('[data-atl-quiz-open]');
      if (openTrigger) {
        e.preventDefault();
        openModal();
        return;
      }
      var closeTrigger = e.target.closest('[data-atl-quiz-close]');
      if (closeTrigger) {
        e.preventDefault();
        closeModal();
        return;
      }
      var startBtn = e.target.closest('[data-atl-qm-start]');
      if (startBtn) {
        e.preventDefault();
        showScreen(modal, 'q1');
        return;
      }
      var restartBtn = e.target.closest('[data-atl-qm-restart]');
      if (restartBtn) {
        e.preventDefault();
        answers = {};
        showScreen(modal, 'intro');
        return;
      }
      var answerBtn = e.target.closest('[data-atl-qm-answer]');
      if (answerBtn) {
        e.preventDefault();
        var raw = answerBtn.getAttribute('data-atl-qm-answer');
        var parts = raw.split(':');
        var key = parts[0], val = parts[1];
        answers[key] = val;
        // Advance to next screen
        var current = answerBtn.closest('[data-atl-qm-screen]').getAttribute('data-atl-qm-screen');
        var next = { q1: 'q2', q2: 'q3', q3: 'result' }[current];
        if (next === 'result') renderResult(modal);
        else if (next) showScreen(modal, next);
        return;
      }
    });

    // ESC closes
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hasAttribute('hidden')) {
        closeModal();
      }
    });
  }

  /* ===== BOOT ===== */
  function start() {
    bindQuiz();
    if (tryInject()) return;
    var attempts = 0;
    var iv = setInterval(function () {
      attempts++;
      if (tryInject() || attempts > 40) clearInterval(iv);
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  window.addEventListener('load', start);
})();
